/**
 * Availability slot API (AIMHI Direct AD-04).
 *
 * Three audiences, matching the server-side split: therapists publish and
 * manage their own slots, clients browse and claim, and admin / clinical
 * supervisors read the oversight schedule.
 */
import api from './api';

const qs = (params) => {
  const entries = Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== '');
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : '';
};

// --- Therapist -------------------------------------------------------------

export const publishSlots = (slots, token) =>
  api.post('/availability-slots/mine', { slots }, token).then(r => r.data);

export const getMySlots = ({ from, to, slotType, status } = {}, token) =>
  api.get(`/availability-slots/mine${qs({ from, to, slotType, status })}`, token).then(r => r.data);

export const cancelMySlot = (slotId, token) =>
  api.delete(`/availability-slots/mine/${slotId}`, token).then(r => r.data);

// --- Client ----------------------------------------------------------------

export const getAvailableSlots = ({ slotType = 'intake', to } = {}, token) =>
  api.get(`/availability-slots/available${qs({ slotType, to })}`, token).then(r => r.data);

export const claimSlot = (slotId, token) =>
  api.post(`/availability-slots/${slotId}/claim`, {}, token).then(r => r.data);

export const releaseSlot = (slotId, token) =>
  api.post(`/availability-slots/${slotId}/release`, {}, token).then(r => r.data);

// --- Admin / clinical supervisor oversight ---------------------------------

export const getSchedule = ({ from, to, therapistId, slotType } = {}, token) =>
  api.get(`/availability-slots/schedule${qs({ from, to, therapistId, slotType })}`, token).then(r => r.data);
